<template>
  <v-app>
    <TheSystemBar />

    <TheNavBar />

    <v-main scrollable>
      <v-progress-linear v-if="userLoading" indeterminate />

      <router-view v-else v-slot="{ Component }">
        <KeepAlive :include="['CourtSessionsPage']">
          <component :is="Component" />
        </KeepAlive>
      </router-view>
    </v-main>

    <TheFooter />

    <TheSnackbar />
  </v-app>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useAuthStore } from './stores/auth'
import { useRouter, useRoute } from 'vue-router'
import { useDictionaryStore } from './stores/dictionary'

const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()
const userLoading = ref(false)

onMounted(async () => {
  userLoading.value = true

  const { isSuccess } = await authStore.fetchUser()
  if (isSuccess) {
    if (authStore.user.employeeType === 'Genikos Diaxeiristis') {
      router.push('/admin')
    } else {
      router.push('/home')
    }
  }

  userLoading.value = false

  // load dictionary when window is idle for performance
  if (window.requestIdleCallback) {
    requestIdleCallback(() => {
      const dictionaryStore = useDictionaryStore()
      dictionaryStore.initialize()
    })
  } else {
    // fallback
    const dictionaryStore = useDictionaryStore()
    dictionaryStore.initialize()
  }
})
</script>
